<template>
<div class="chapter">
<div class="inner_page">
<p class="noindenta"><a id="page_ii"></a><em class="italic">Cover image</em>: Pilots Travers and Noel with their Farman at Eastbourne in 1912.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Front.vue?3932fb96